import canvasTxt from "canvas-txt";
import { roundRect } from "./roundRect";

import { characters } from "../data/characters";

import redBGURL from "../assets/share/red-bg.png";
import tssLogoURL from "../assets/share/logo.png";
import beatMyHighScoreURL from "../assets/share/beat-my-high-score.png";
import imaxLogoURL from "../assets/share/imax.png";
import bigWinLabelURL from "../assets/share/big-win.png";
import epicFailLabelURL from "../assets/share/epic-fail.png";
import aaschenBoldURL from "../assets/aaschen-bold.otf";

const loadImage = async (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.onerror = reject;
    img.onload = () => {
      resolve(img);
    };
  });
};

const loadFont = async (name, url) => {
  return new Promise((resolve, reject) => {
    const font = new FontFace(name, url);
    font.load().then(() => {
      document.fonts.add(font);
      resolve(font);
    });
  });
};

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const generateImage = async (
  bigWin,
  epicFail,
  rankings,
  totalPoints
) => {
  // load assets
  const [
    redBg,
    tssLogo,
    beatMyHighScore,
    imaxLogo,
    bigWinLabel,
    epicFailLabel,
    bigWinIcon,
    epicFailIcon,
  ] = await Promise.all([
    loadImage(redBGURL),
    loadImage(tssLogoURL),
    loadImage(beatMyHighScoreURL),
    loadImage(imaxLogoURL),
    loadImage(bigWinLabelURL),
    loadImage(epicFailLabelURL),
    loadImage(characters[bigWin.characterId].shareIcon),
    loadImage(characters[epicFail.characterId].shareIcon),
    loadFont("Aaschen Bold", `url(${aaschenBoldURL})`),
  ]);

  const canvas = document.createElement("canvas");
  canvas.width = 1080;
  canvas.height = 1920;
  const ctx = canvas.getContext("2d");

  // draw background
  ctx.drawImage(redBg, 0, 0);

  // Logos
  ctx.drawImage(tssLogo, canvas.width / 2 - tssLogo.width / 2, 50);
  ctx.drawImage(imaxLogo, canvas.width / 2 - imaxLogo.width / 2, 1770);

  // Score container
  ctx.globalAlpha = 0.08;
  roundRect(ctx, 100, 550, canvas.width - 200, 360, 80, "#000000");
  ctx.globalAlpha = 1;
  ctx.drawImage(beatMyHighScore, canvas.width / 2 - tssLogo.width / 2, 490);

  // Score labels
  ctx.textAlign = "center";
  ctx.font = "700 48px Aaschen Bold";
  ctx.fillStyle = "#000000";
  ctx.textAlign = "left";
  ctx.fillText("POINTS", 180, 680);
  ctx.fillText("RANK", 180, 780);

  // Score and rankings
  const cityRank = rankings.city.rank;
  const globalRank = rankings.global.rank;
  ctx.textAlign = "right";
  ctx.font = "700 120px Montserrat";
  ctx.fillStyle = "#FFFFFF";
  ctx.fillText(numberWithCommas(totalPoints), 950, 700);
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "36px Montserrat";
  ctx.fillText("CITY", 620, 780);
  ctx.fillText("GLOBAL", 620, 860);
  ctx.font = "700 48px Montserrat";
  const testNumber = !`#${numberWithCommas(12345678)}`;
  ctx.fillText(testNumber || `#${numberWithCommas(cityRank)}`, 940, 780);
  ctx.fillText(testNumber || `#${numberWithCommas(globalRank)}`, 940, 860);

  // Big Win container
  ctx.strokeStyle = "#FFFFFF";
  ctx.lineWidth = 7;
  ctx.textAlign = "center";
  ctx.font = "48px Montserrat";
  roundRect(ctx, 100, 1000, canvas.width - 200, 300, 80);
  ctx.drawImage(bigWinLabel, canvas.width / 2 - bigWinLabel.width / 2, 940);

  // canvas-txt settings
  canvasTxt.fontSize = 52;
  canvasTxt.font = "Aaschen Bold";
  canvasTxt.debug = false;
  canvasTxt.vAlign = "top";

  const testString = !"WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW";

  // Big Win data
  ctx.textAlign = "center";
  ctx.font = "48px Montserrat";
  ctx.drawImage(bigWinIcon, 100, 960);
  ctx.fillText(bigWin.category, 680, 1080);
  canvasTxt.drawText(ctx, testString || bigWin.name, 400, 1090, 550, 180);

  // Epic Fail container
  ctx.strokeStyle = "#FFFFFF";
  ctx.lineWidth = 7;
  const epicFailStartY = 1400;
  roundRect(ctx, 100, epicFailStartY, canvas.width - 200, 300, 80);
  ctx.drawImage(epicFailIcon, 100, epicFailStartY - 40);
  ctx.drawImage(
    epicFailLabel,
    canvas.width / 2 - epicFailLabel.width / 2,
    epicFailStartY - 50
  );

  // Epic Fail data
  ctx.textAlign = "center";
  ctx.font = "48px Montserrat";
  ctx.fillText(epicFail.category, 680, epicFailStartY + 90);
  canvasTxt.drawText(
    ctx,
    testString || epicFail.name,
    400,
    epicFailStartY + 100,
    550,
    180
  );

  return canvas.toDataURL("image/png");
};
